module.exports = __webpack_public_path__ + "static/img/4.ae4efb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/4.png
// module id = 61A2
// module chunks = 0